import React, { useState } from 'react';
import { XIcon, SparklesIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function AnnouncementBar() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <AnimatePresence data-id="element-13">
      <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: 'auto',
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} className="bg-pulse-blue text-pulse-navy" data-id="element-14">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-center gap-4 relative" data-id="element-15">
          <SparklesIcon className="h-5 w-5 flex-shrink-0 animate-pulse" aria-hidden="true" data-id="element-16" />
          <p className="text-sm md:text-base font-semibold text-center" data-id="element-17">
            <span className="hidden sm:inline" data-id="element-18">
              🚀 Something BIG is Coming to Midlothian, VA —{' '}
            </span>
            <span className="font-bold" data-id="element-19">Stay Tuned!</span>
          </p>
          <a href="#signup" className="hidden sm:inline-flex bg-pulse-navy text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide hover:bg-pulse-navy-light transition-colors" data-id="element-20">
            Get Notified
          </a>
          <button onClick={() => setIsVisible(false)} className="absolute right-4 p-1 hover:bg-white/20 rounded-full transition-colors" aria-label="Dismiss announcement" data-id="element-21">
            <XIcon className="h-4 w-4" data-id="element-22" />
          </button>
        </div>
      </motion.div>
    </AnimatePresence>;
}